<template>
    <div class="item-question-input-rate-on-a-scale">
        <div class="d-flex flex-row">
            <label v-if="numberContent != ''" class="text-color-number mb-1">
                {{ numberContent }}
            </label>
            <label class="text-color-questions mb-1 ps-2"
                   v-html="labelContent">
            </label>
        </div>
        <div
            v-if="question.additionalInfo"
            class="form-input-help mb-1"
            v-html="question.additionalInfo"
        >
        </div>
        <div class="distribute-evenly-forms rate-scales-columns">
            <label/>
            <div role="group" aria-labelledby="formulate-global-1_label" class="formulate-input-element formulate-input-element--group formulate-input-group distribute-evenly-forms">
                <div v-for="itemScale in question.scales"
                     :key="itemScale.scaleId"
                     :style="'width: ' + widthCalc + '%;'"
                     class="text-center py-2">
                    <label
                        :title="whiteSpace(itemScale.description)"
                    >
                        {{ whiteSpace(itemScale.description) }}
                    </label>
                </div>
            </div>
        </div>
        <matrix-radio-input v-for="(option, index) in question.options"
                     :key="index"
                     :error-text="translate('label.this_value_is_required')"
                     :field-id="parseInt(option.optionId)"
                     :input-class="'form-check-input question-input-radio'"
                     :label="option.description"
                     :model-answer="option.answer.toString()"
                     :name="'question_' + TYPE_FIELD_ID + '_' + question.questionId + '_' + option.optionId"
                     :options="options"
                     :question="question"
                     :type="'radio'"
                     :type-field-id="TYPE_FIELD_ID"
                     :validation="validationRules"
                     :wrapper-class="'distribute-evenly-forms'"
                     :element-class="'distribute-evenly-forms'"
                     :has-submitted="hasSubmitted"
                     @update:modelAnswer="changeValue($event, option)"
                     @register-field="handleFieldRegister"
                     @field-change="handleFieldChange"
        />
    </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import MatrixRadioInput from "../components/matrix-radio-input.vue";
import { useTranslation } from '@/composables/useTranslation';

// INITIALIZE STORES AND COMPOSABLES
const playerStore = usePlayerStore();
const { translate } = useTranslation();

// PROPS AND EMITS
const props = defineProps({
    enumeration: {
        type: Number,
        required: false,
        default: 0,
    },
    question: {
        type: Object,
        required: true,
    },
    showNumbering: {
        type: Boolean,
        required: false,
        default: false,
    },
    translateLabels: {
        type: Object,
        required: true,
    },
    TYPE_FIELD_ID: {
        type: Number,
        required: true,
    },
    hasSubmitted: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['field-change', 'register-field']);

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const options = computed(() => {
    const options = {};
    props.question.scales.forEach((scale) => {
        options[scale.scaleId] = '';
    });
    return options;
});

const widthCalc = computed(() => {
    return (75 / props.question.scales.length).toFixed(2);
});

const validationRules = computed(() => {
    const rules = {
        required: false,
    };
    if (props.question.required) {
        rules.required = true;
    }

    return rules;
});

const labelContent = computed(() => {
    const label = [];

    if (Boolean(props.question.required)) {
        label.push(`* ${props.question.description}`);
    } else {
        label.push(props.question.description);
    }

    return label.join(' ');
});

const numberContent = computed(() => {
    const label = [];

    if (Boolean(props.showNumbering)) {
        label.push(`${String(props.enumeration).padStart(2, '0')}.`);
    }

    return label.join(' ');
});

// METHODS
const whiteSpace = (a) => {
    return String(a).trim();
};

const generateFieldName = (optionId) => {
    return `question_${props.TYPE_FIELD_ID}_${props.question.questionId}_${optionId}`;
};

const changeValue = (newValue, option) => {
    option.answer = newValue;
    const fieldName = generateFieldName(option.optionId);
    emit('field-change', fieldName, newValue);

    // Actualizar correctamente en el store manteniendo todas las opciones
    const updatedQuestion = { ...props.question };
    const optionIndex = updatedQuestion.options.findIndex(opt => opt.optionId === option.optionId);
    if (optionIndex !== -1) {
        updatedQuestion.options[optionIndex].answer = newValue;
    }

    playerStore.setAnswerInFormQuestions(updatedQuestion);
};

const handleFieldRegister = (fieldName, initialValue) => {
    emit('register-field', fieldName, initialValue);
};

const handleFieldChange = (fieldName, value) => {
    emit('field-change', fieldName, value);
};

// LIFECYCLE HOOKS
onMounted(async () => {
    props.question.options.forEach((option) => {
        const fieldName = generateFieldName(option.optionId);
        const initialValue = option.answer || '';
        emit('register-field', fieldName, initialValue);
    });
});
</script>
